import { LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface MobileTopBarProps {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
}

export function MobileTopBar({ title, showBack, onBack }: MobileTopBarProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    navigate(-1);
  };

  return (
    <header className="mobile-top-bar">
      {showBack ? (
        <button type="button" className="mobile-top-bar__back" onClick={handleBack} aria-label="返回">
          <LeftOutlined />
        </button>
      ) : null}
      <h1 className="mobile-top-bar__title">{title}</h1>
    </header>
  );
}
